import type {
  ClientChat,
  ClientPersonReference
} from '@DigitaleDoerfer/digitale-doerfer-api';

export const findChatBetweenPersons = (
  chats: ClientChat[],
  firstPersonId: string,
  secondPersonId: string
): ClientChat | undefined => {
  const matchingChats = chats.filter(
    (chat) =>
      chat.chatParticipants?.length === 2 &&
      ((chat.chatParticipants[0].person?.id === firstPersonId &&
        chat.chatParticipants[1].person?.id === secondPersonId) ||
        (chat.chatParticipants[0].person?.id === secondPersonId &&
          chat.chatParticipants[1].person?.id === firstPersonId))
  );
  if (matchingChats.length > 1) {
    console.error(
      `Found multiple chats between ${firstPersonId} and ${secondPersonId}`
    );
  }
  return matchingChats[0];
};

export const getChatPartner = (
  chat: ClientChat,
  ownUserId: string
): ClientPersonReference | undefined => {
  if (chat.chatParticipants?.length === 1) {
    // The user interacts with himself
    return chat.chatParticipants[0]?.person;
  }
  const otherParticipants = chat.chatParticipants?.filter(
    (participant) => participant.person?.id !== ownUserId
  );
  if (otherParticipants) {
    if (otherParticipants.length > 1) {
      console.warn(`Chat ${chat.id} has more than one another participants`);
    } else if (otherParticipants.length === 0) {
      console.warn(`Chat ${chat.id} has no other participants`);
    }
    return otherParticipants[0]?.person;
  }
};
